import { SharedDocumalisModule } from '@documalis/shared-documalis.module';
import { NgModule } from '@angular/core';
import { CustMenuBaseRoutes } from './custmenubase.routes';
import { ListCustMenuBaseComponent } from './list-custmenubase/list-custmenubase.component';
import { FormCustMenuBaseComponent } from './_components/form-custmenubase/form-custmenubase.component';
import { AddCustMenuBaseComponent } from './add-custmenubase/add-custmenubase.component';
import { EditCustMenuBaseComponent } from './edit-custmenubase/edit-custmenubase.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [CustMenuBaseRoutes, SharedDocumalisModule, TranslateModule],
    declarations: [ListCustMenuBaseComponent, AddCustMenuBaseComponent, EditCustMenuBaseComponent, FormCustMenuBaseComponent],
})
export class CustMenuBaseModule {}
